module.exports = __webpack_public_path__ + "img/nap_02.efad67b2.jpg";